<template>
  <button
    class="text-xl font-medium text-brand text-nowrap"
    @click="handleInvoiceStart"
  >
    + {{ $t('b2b|invoices|button|create_invoice') }}
  </button>

  <modal-invoice v-model="showCreateInvoice" @onSubmit="submitCreateInvoice" />
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import ModalInvoice from '@/widgets/ModalInvoice/ui/ModalInvoice.vue'
import { usePartner } from '@/shared/composables/usePartner'

import { INVOICES_ROUTES } from '@/shared/constants'
import { PRODUCT_NAMES } from '@/shared/constants/products'
import segmentService from '@/shared/services/segment.service'
import { ANALYTICS_EVENT_TYPE } from '@/packages/auth-service/requiredUserAction/shared/utils/analytics'

const router = useRouter()
const showCreateInvoice = ref(false)
const { checkProductAccess } = usePartner()

async function handleInvoiceStart() {
  const hasAccess = await checkProductAccess(PRODUCT_NAMES.INVOICES)
  if (!hasAccess) {
    return
  }
  segmentService.trackNewEvent(ANALYTICS_EVENT_TYPE.CLICK, {
    event: ANALYTICS_EVENT_TYPE.CLICK,
    page: 'invoices_start',
    screen: 'invoices_start',
    button_name: 'create_invoice',
  })
  showCreateInvoice.value = true
}

function submitCreateInvoice(invoice) {
  if (invoice && invoice.id) {
    showCreateInvoice.value = false
    router.push({ name: INVOICES_ROUTES.DETAIL, params: { id: invoice.id } })
  }
}
</script>
